export default {"src":"/_next/static/media/ADVANCE_FILTERS.0a25cfa7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};